export default __webpack_public_path__ + "static/media/search.46b377a0.png";